import React, { Component } from "react";
import request from "superagent";
import { urlPlayer, urlPlayerPreview, url_endpoint, url_s3 } from "../config";
import { Update, Forward10, Replay10, Label, Link } from "@material-ui/icons";
import ReactAudioPlayer from "react-audio-player";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import PauseIcon from "@material-ui/icons/Pause";
import ShareIcon from "@material-ui/icons/Share";
import Cancel from "@material-ui/icons/Close";
import GetAppIcon from "@material-ui/icons/GetApp";

import SettingsInputAntennaIcon from "@material-ui/icons/SettingsInputAntenna";
import { Helmet } from "react-helmet";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
} from "react-share";

import iconAgredSpotfi from "../images/agregadores/spotify.png";
import iconAgredGoogle from "../images/agregadores/google.png";
import iconAgredItunes from "../images/agregadores/itunes.png";
import logoBlogplay from "../images/logo_blogplay.png";

import FirebaseService from "../services/FirebaseService";

let positionClicked = 0;
const defaultPlayerColor = {
  corfundo: "#6A6A6A",
};
class Player extends Component {
  constructor(props) {
    super(props);
    this.state = {
      player_data: {},
      playing: false,
      tempo_total: "00:00",
      tempo_atual: "00:00",
      progressbar: 0,
      agregadorOpen: false,
      compartilharOpen: false,
      updateOpen: false,
      speed: 1,
      prefs: {
        ...this.props,
      },
      shareUrl: "",
      shareUrlImage: "",
      changeTimeStarted: false,
      imageBackground: '',
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      this.setState({ prefs: this.props });
    }

    document.querySelector('iframe').src = urlPlayerPreview + this.props.match.params.id
  }

  async componentDidMount() {
    // try {
    //   const res = await request.get(
    //     url_endpoint + "podcast/player/" + this.props.match.params.id
    //   );
    //   console.log(res)
    //   document.title = res.body.titulo;

    //   let append = {};
    //   if (this.props.cortexto === undefined)
    //     append = { prefs: res.body.Cliente };
    //   this.setState({ player_data: res.body, ...append });

    //   const shareUrl =
    //     window.location.origin + "/player/" + this.props.match.params.id;
    //   const shareUrlImage = this.state.player_data.imagem.includes('digitalocean') ? this.state.player_data.imagem : url_s3 + this.state.player_data.imagem;
    //   const audioUrl = this.state.player_data.arquivo.includes('digitalocean') ? this.state.player_data.arquivo : url_s3 + this.state.player_data.arquivo;

    //   const imageBackground = this.state.player_data.imagem.includes('digitalocean') ? this.state.player_data.imagem : url_s3 + this.state.player_data.imagem
    //   this.setState({
    //     shareUrl: shareUrl,
    //     title: res.body.titulo,
    //     shareUrlImage: shareUrlImage,
    //     audioUrl: audioUrl,
    //     imageBackground: imageBackground
    //   });

    // } catch (err) {
    //   alert(err);
    // }
    // this.timer = setInterval(() => {
    //   const current = this.player.audioEl.currentTime;
    //   const progressbar = (current * 100) / this.player.audioEl.duration;
    //   this.setState({ tempo_atual: this.mmss(current), progressbar });
    // }, 20);
  }
  componentWillUnmount() {
    // clearInterval(this.timer);
  }

  changeTime = (evt) => {
    if (this.state.changeTimeStarted) {
      positionClicked = positionClicked =
        evt.pageX - evt.currentTarget.offsetLeft;
      if (parseInt(this.state.prefs.layout) === 0 || !this.state.prefs.layout)
        positionClicked = evt.pageX - evt.currentTarget.offsetLeft - 150;

      const timeSelected =
        (positionClicked * this.player.audioEl.duration) /
        evt.currentTarget.clientWidth;
      this.player.audioEl.currentTime = timeSelected;

      if (this.player.audioEl.currentTime >= this.player.audioEl.duration)
        this.setState({ playing: false });
      //console.log(evt)
    }
  };
  startChangeTime = (evt) => {
    positionClicked = positionClicked =
      evt.pageX - evt.currentTarget.offsetLeft;
    // let p = positionClicked = evt.pageX - evt.currentTarget.offsetLeft;
    if (parseInt(this.state.prefs.layout) === 0 || !this.state.prefs.layout)
      positionClicked = evt.pageX - evt.currentTarget.offsetLeft - 150;

    const timeSelected =
      (positionClicked * this.player.audioEl.duration) /
      evt.currentTarget.clientWidth;
    this.player.audioEl.currentTime = timeSelected;
    this.setState({ changeTimeStarted: true });
  };
  stopChangeTime = (evt) => {
    this.setState({ changeTimeStarted: false });
  };

  saveStatisticPlayer = async (acao) => {
    try {
      FirebaseService.saveOnPlay(
        this.state.player_data.ClienteId,
        this.props.match.params.id,
        acao,
        (ret, error) => {
          if (error) {
            console.log(error);
          }
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  togglePlay = () => {
    if (this.state.playing) this.player.audioEl.pause();
    else {
      this.player.audioEl.play();
      this.saveStatisticPlayer("play");
    }
    this.setState({ playing: !this.state.playing });
  };
  mmss(secs) {
    secs = parseInt(secs);
    const minutes = Math.floor(secs / 60);
    secs = secs % 60;
    return `${this.pad(minutes)}:${this.pad(secs)}`;
  }
  setSpeed = (speed) => {
    this.player.audioEl.playbackRate = speed;
    this.setState({ speed, updateOpen: false });
  };
  pad(num) {
    return ("0" + num).slice(-2);
  }

  openLinkAgregador = (url, tipoAgre) => {
    if (url && url.length > 0) {
      window.open(url, "_blank");

      let objSave = {};
      FirebaseService.saveOnPlay(
        this.state.player_data.ClienteId,
        this.props.match.params.id,
        "agregador_" + tipoAgre,
        (ret, error) => {
          if (error) {
            console.log(error);
          }
        }
      );
      /*  FirebaseService.saveOnPlay('postcast/' + this.state.player_data.ClienteId + '/' + this.props.match.params.id + '/agregador/' + tipoAgre + '/', objSave, (ret, error) => {

                if (error) {
                    console.log(error)
                }
            }); */
    }
  };

  saveEventShare = (destino) => {
    //save view
    try {
      let objSave = {};
      FirebaseService.saveOnPlay(
        this.state.player_data.ClienteId,
        this.props.match.params.id,
        "share_" + destino,
        (ret, error) => {
          if (error) {
            console.log(error);
          }
        }
      );
      /* FirebaseService.saveOnPlay('postcast/' + this.state.player_data.ClienteId + '/' + this.props.match.params.id + '/share/' + destino + '/', objSave, (ret, error) => {

                if (error) {
                    console.log(error)
                }

            }); */
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      // <iframe src={"http://testeplayer.s3-website-us-east-1.amazonaws.com/" + this.props.match.params.id} style={{border: 'none', width: '100%'}}></iframe>
      <iframe src={urlPlayerPreview + this.props.match.params.id} style={{border: 'none', width: '100%'}}></iframe>
    )
    return (
      <div style={{ position: "relative" }}>
        <Helmet>
          <title>{this.state.player_data.titulo}</title>

          <link
            rel="icon"
            type="image/png"
            href={this.state.shareUrlImage}
            sizes="192x192"
          />
        </Helmet>
        {this.state.agregadorOpen && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              textAlign: "center",
              background: "rgba(0,0,0,0.8)",
              zIndex: 9999,
              color: "white",
            }}
          >
            <div
              onClick={(_) => this.setState({ agregadorOpen: false })}
              style={{
                cursor: "pointer",
                right: 10,
                top: 5,
                position: "absolute",
                color: this.state.prefs.cortexto,
              }}
            >
              <Cancel style={{ fontSize: "2.5rem", cursor: "pointer" }} />
            </div>

            <h2 style={{ fontWeight: 300 }}>Ouça no seu agregador favorito:</h2>

            <div style={{ textAlign: "center", display: "inline-block" }}>
              <div style={{ display: "flex", width: "fit-content" }}>
                <img
                  src={iconAgredSpotfi}
                  onClick={(_) =>
                    this.openLinkAgregador(
                      this.state.player_data.url_post_spotify ||
                        this.state.player_data.Cliente.url_post_spotify,
                      "spotify"
                    )
                  }
                  className={
                    this.state.player_data.url_post_spotify ||
                    this.state.player_data.Cliente.url_post_spotify
                      ? "icons-agregadores"
                      : "icons-agregadores-disabled"
                  }
                />
                <img
                  src={iconAgredGoogle}
                  onClick={(_) =>
                    this.openLinkAgregador(
                      this.state.player_data.url_post_google ||
                        this.state.player_data.Cliente.url_post_google,
                      "google"
                    )
                  }
                  className={
                    this.state.player_data.url_post_google ||
                    this.state.player_data.Cliente.url_post_google
                      ? "icons-agregadores"
                      : "icons-agregadores-disabled"
                  }
                />
                <img
                  src={iconAgredItunes}
                  onClick={(_) =>
                    this.openLinkAgregador(
                      this.state.player_data.url_post_itunes ||
                        this.state.player_data.Cliente.url_post_itunes,
                      "itunes"
                    )
                  }
                  className={
                    this.state.player_data.url_post_itunes ||
                    this.state.player_data.Cliente.url_post_itunes
                      ? "icons-agregadores"
                      : "icons-agregadores-disabled"
                  }
                />
              </div>
            </div>
          </div>
        )}
        {this.state.compartilharOpen && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              textAlign: "center",
              background: "rgba(0,0,0,0.8)",
              zIndex: 9999,
              color: "white",
            }}
          >
            {/* <img src={close} style={{ cursor: 'pointer', right: 10, top: 10, position: "absolute" }} onClick={_ => this.setState({ compartilharOpen: false })} width={30} /> */}
            <div
              onClick={(_) => this.setState({ compartilharOpen: false })}
              style={{
                cursor: "pointer",
                right: 10,
                top: 5,
                position: "absolute",
                color: this.state.prefs.cortexto,
              }}
            >
              <Cancel style={{ fontSize: "2.5rem", cursor: "pointer" }} />
            </div>

            <h2 style={{ fontWeight: 300 }}>Compartilhe este Áudios</h2>
            <div style={{ textAlign: "center", display: "inline-block" }}>
              <div style={{ display: "flex", width: "fit-content" }}>
                <a
                  href="#"
                  onMouseUp={(evt) => this.saveEventShare("facebook")}
                >
                  <FacebookShareButton
                    url={this.state.shareUrl}
                    quote={this.state.title}
                    className="icons-agregadores"
                    picture={this.state.shareUrlImage}
                  >
                    <FacebookIcon size={45} round />
                  </FacebookShareButton>
                </a>

                <a href="#" onClick={(evt) => this.saveEventShare("twitter")}>
                  <TwitterShareButton
                    url={this.state.shareUrl}
                    quote={this.state.title}
                    className="icons-agregadores"
                  >
                    <TwitterIcon size={45} round />
                  </TwitterShareButton>
                </a>

                <a href="#" onClick={(evt) => this.saveEventShare("linkedin")}>
                  <LinkedinShareButton
                    url={this.state.shareUrl}
                    quote={this.state.title}
                    className="icons-agregadores"
                  >
                    <LinkedinIcon size={45} round />
                  </LinkedinShareButton>
                </a>

                <a href="#" onClick={(evt) => this.saveEventShare("whatsapp")}>
                  <WhatsappShareButton
                    url={this.state.shareUrl}
                    quote={this.state.title}
                    image={this.state.shareUrlImage}
                    className="icons-agregadores"
                  >
                    <WhatsappIcon size={45} round />
                  </WhatsappShareButton>
                </a>
              </div>
            </div>
          </div>
        )}
        <div>
          {(this.state.prefs.layout === undefined ||
            parseInt(this.state.prefs.layout) === 0) && (
            <div
              style={{
                display: "inline-block",
                position: "relative",
                // background: "url(" + this.state.player_data.imagem.includes('digitalocean') ? this.state.player_data.imagem : url_s3 + this.state.player_data.imagem + ")",

                // background: "url('" + this.state.player_data.imagem.includes('digitalocean') ? this.state.player_data.imagem : url_s3 + this.state.player_data.imagem + "')",
                background: this.state.imageBackground,
                width: "150px",
                height: "150px",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                borderRadius: "7px 0px 0px 7px",
              }}
              // onClick={(evt) => this.saveStatisticPlayer("click_logo")}
            ></div>
          )}

          <div
            style={{
              display: "inline-block",
              verticalAlign: "top",
              width:
                parseInt(this.state.prefs.layout) === 0 ||
                this.state.prefs.layout === undefined
                  ? "calc(100% - 150px)"
                  : "100%",
              overflow: "hidden",
              height:
                !this.state.prefs.layout ||
                parseInt(this.state.prefs.layout) !== 3
                  ? "150px"
                  : "auto",
              color: "white",
              fontFamily: "Lato, sans-serif",
            }}
          >
            {this.state.player_data.Cliente && (
              <div
                style={{
                  padding:
                    this.state.prefs.layout &&
                    parseInt(this.state.prefs.layout) === 3
                      ? "28px 5px 7px 10px"
                      : "17px 10px 7px 30px",
                  overflow: "hidden",
                  position: "relative",
                  borderRadius:
                    !this.state.prefs.layout ||
                    parseInt(this.state.prefs.layout) === 0
                      ? "0px 5px 7px 0px"
                      : "7px",
                  height: "100%",
                }}
              >
                <div
                  className={"blur_bg"}
                  style={{
                    background:
                      parseInt(this.state.prefs.layout) === 0 ||
                      parseInt(this.state.prefs.layout) === 1 // parseInt(this.state.prefs.layout) != 2
                        ? "url('" + this.state.player_data.imagem.includes('digitalocean') ? this.state.player_data.imagem : url_s3 + this.state.player_data.imagem +
                          "')"
                        : this.state.prefs.corfundo,
                    transform: "scale(1.1)",
                  }}
                >
                  <div></div>
                </div>

                <div className={"botoes_right"}>
                  <div
                    onClick={(_) => this.setState({ agregadorOpen: true })}
                    style={{
                      display: "inline-block",
                      verticalAlign: "top",
                      padding: "6px 8px",
                      color: this.state.prefs.cortexto,
                      borderRadius: "0px 0px 0px 13px",
                      backgroundColor: this.state.prefs.corbotoes,
                    }}
                  >
                    <SettingsInputAntennaIcon
                      style={{ fontSize: "1.7rem", cursor: "pointer" }}
                    />
                  </div>
                  <div
                    onClick={(_) => this.setState({ compartilharOpen: true })}
                    style={{
                      display: "inline-block",
                      verticalAlign: "top",
                      padding: "6px 8px",
                      color: this.state.prefs.cortexto,
                      backgroundColor: this.state.prefs.corbotoes,
                    }}
                  >
                    <ShareIcon
                      style={{ fontSize: "1.7rem", cursor: "pointer" }}
                    />
                  </div>
                  {this.state.prefs.permitirDownload && <a
                    href={this.state.player_data.arquivo.includes('digitalocean') ? this.state.player_data.arquivo : url_s3 + this.state.player_data.arquivo}
                    target={"_blank"}
                    onClick={(evt) => this.saveStatisticPlayer("download")}
                  >
                    <div
                      style={{
                        display: "inline-block",
                        verticalAlign: "top",
                        padding: "6.5px 8px",
                        color: this.state.prefs.cortexto,
                        backgroundColor: this.state.prefs.corbotoes,
                      }}
                    >
                      <GetAppIcon
                        style={{ verticalAlign: "middle", fontSize: "1.9rem" }}
                      />
                    </div>
                  </a>}
                  {/*<img onClick={_=>this.setState({agregadorOpen: true})} src={agregadores} width={50}/>*/}
                  {/*<img onClick={_=>this.setState({compartilharOpen: true})}  src={compartilhar} width={42}/>*/}
                  {/*<a href={url_s3+this.state.player_data.arquivo} target={"_blank"}><img src={download} width={42} /></a>*/}
                </div>
                {this.state.prefs.layout !== undefined &&
                  parseInt(this.state.prefs.layout) != 3 && (
                    <div>
                      <h3
                        style={{
                          margin: 0,
                          fontWeight: 300,
                          fontSize: 24,
                          marginBottom: 2,
                          width: "calc(100% - 125px)",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          color: this.state.prefs.cortitulo
                        }}
                      >
                        {this.state.player_data.titulo}
                      </h3>
                      <h4
                        style={{
                          margin: 0,
                          fontSize: 16,
                          marginBottom: 10,
                          color: this.state.prefs.cortexto,
                        }}
                      >
                        {this.state.player_data.Cliente.nome}
                      </h4>
                    </div>
                  )}

                <div className={"player_content"}>
                  <div style={{ display: "inline-block" }}>
                    <Replay10
                      style={{
                        color: this.state.prefs.corsecundaria,
                        verticalAlign: "top",
                        marginTop: 15,
                        fontSize: 30,
                      }}
                      onClick={(_) => (this.player.audioEl.currentTime -= 10)}
                    />
                    {this.state.playing ? (
                      <div
                        onClick={(_) => this.togglePlay()}
                        style={{
                          display: "inline-block",
                          border: `1px solid ${this.state.prefs.corsecundaria}`,
                          marginTop: "4px",
                          borderRadius: "100%",
                          width: 49,
                          height: 49,
                          cursor: "pointer",
                        }}
                      >
                        <PauseIcon
                          style={{
                            width: "100%",
                            height: "100%",
                            color: this.state.prefs.corbotoes,
                          }}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={(_) => this.togglePlay()}
                        style={{
                          display: "inline-block",
                          border: `1px solid ${this.state.prefs.corsecundaria}`,
                          marginTop: "4px",
                          borderRadius: "100%",
                          width: 49,
                          height: 49,
                          cursor: "pointer",
                        }}
                      >
                        <PlayArrowIcon
                          style={{
                            width: "100%",
                            height: "100%",
                            color: this.state.prefs.corbotoes,
                          }}
                        />
                      </div>
                    )}
                    <Forward10
                      style={{
                        color: this.state.prefs.corsecundaria,
                        verticalAlign: "top",
                        marginTop: 15,
                        fontSize: 30,
                      }}
                      onClick={(_) => (this.player.audioEl.currentTime += 10)}
                    />
                  </div>
                  <div
                    style={{
                      display: "inline-block",
                      marginLeft: 15,
                      width: "calc(100% - 180px)",
                      verticalAlign: "top",
                      marginRight: 10,
                      marginTop: 25,
                      color: this.state.prefs.corsecundaria
                    }}
                  >
                    <div
                      className={"progress"}
                      style={{backgroundColor: this.state.prefs.corsecundaria}}
                      onMouseDown={this.startChangeTime}
                      onMouseMove={this.changeTime}
                      onMouseLeave={this.stopChangeTime}
                      onMouseUp={this.stopChangeTime}
                    >
                      <div
                        style={{
                          width: this.state.progressbar + "%",
                          backgroundColor: this.state.prefs.corbotoes,
                        }}
                      ></div>
                    </div>
                    <div className={"time_run"} style={{ float: "left" }}>
                      {this.state.tempo_atual}
                    </div>
                    <div className={"time_total"} style={{ float: "right" }}>
                      {this.state.tempo_total}
                    </div>
                    <ReactAudioPlayer
                      ref={(element) => {
                        this.player = element;
                      }}
                      src={this.state.player_data.arquivo.includes('digitalocean') ? this.state.player_data.arquivo : url_s3 + this.state.player_data.arquivo}
                      onCanPlay={() =>
                        this.setState({
                          tempo_total: this.mmss(this.player.audioEl.duration),
                        })
                      }
                    />
                  </div>
                  {this.state.updateOpen && (
                    <div
                      style={{
                        right: 5,
                        top: 104,
                        background: this.state.prefs.corbotoes,
                        position: "absolute",
                        padding: "0px 50px 0px 15px",
                        borderRadius: 20,
                      }}
                    >
                      <ul class={"listTimes"}>
                        {[0.5, 0.75, 1, 1.5, 2].map((i) => {
                          return (
                            <li
                              style={{ color: this.state.prefs.cortexto }}
                              {...(i === this.state.speed && {
                                className: "selected",
                                style: {
                                  color: this.state.prefs.cortextoselecionado,
                                },
                              })}
                              onClick={(_) => this.setSpeed(i)}
                            >
                              {i}x
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                  <Update
                    style={{
                      color: this.state.prefs.corsecundaria,
                      verticalAlign: "top",
                      marginTop: 15,
                      fontSize: 30,
                    }}
                    onClick={(_) =>
                      this.setState({ updateOpen: !this.state.updateOpen })
                    }
                  />
                </div>
              </div>
            )}
          </div>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              position: "relative",
              marginTop: parseInt(this.state.prefs.layout) === 0 ? -3 : 0,
            }}
          >
            <a href={"https://blogplay.com.br/"} target={"_blank"}>
              <img src={logoBlogplay} style={{ width: 130, height: "auto" }} />
            </a>
          </div>
        </div>
      </div>
    );
  }
}
//criar
export default Player;
